<style>
    .store-link {
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.3s, box-shadow 0.3s;

    }


    .store-img {
        height: 50px;
        object-fit: contain;
        margin-top: -4px;
        height: 80%;
        display: block;
        cursor: pointer;
        transition: transform 0.2s, box-shadow 0.2s;
    }

    .store-g-img {
        height: 50px;
        margin-top: -4px;
        object-fit: cover;
        cursor: pointer;
        transition: transform 0.2s, box-shadow 0.2s;
    }
</style>


<div class="overflow-hidden">
    <div class="h-24 w-full flex justify-center">
        <img class="w-32 " src="../assets/img/illustrations/undraw_progressive_app_m-9-ms (1).svg" alt="">
    </div>
    <div class="capitalize mt-2 text-center" style="font-family:Verdana ;">
        <span>for better experience download our mobile application also available in app
            store.</span>
    </div>
    <div style="display: flex; justify-content: center; align-items: center; gap: 16px; margin-top: 5px;">
        <a href="https://play.google.com/store/apps/details?id=com.neml.nafedauctions&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
            target="_blank" class="store-link">
            <img alt="Get it on Google Play"
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                class="store-g-img" />
        </a>

        <a href="https://apps.apple.com/in/app/neml-eauctions/id6496356921?itsct=apps_box_badge&amp;itscg=30200"
            target="_blank" class="store-link">
            <img alt="Download on the App Store"
                src="https://toolbox.marketingtools.apple.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1718323200"
                class="store-img" />
        </a>
    </div>
</div>